import {PickKeys} from "ts-essentials";

/** Either a key of an input type or a pure function over that type */
export type Lens<T, U, Context extends unknown[] = []> = PickKeys<T, U> | ((x: T, ...context: Context) => U);

/** Applies a lens to an object */
export const applyLens = <T, U, Context extends unknown[]>(lens: Lens<T, U, Context>, x: T, ...context: Context): U =>
    typeof lens === "function" ? lens(x, ...context) : x[lens] as any as U;
